import React from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

export const Italic = React.forwardRef<SVGSVGElement | null, IconBaseProps>(function Italic({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <path
      d='M7.91667 3.33334C7.68655 3.33334 7.5 3.51989 7.5 3.75001V4.33334C7.5 4.56346 7.68655 4.75001 7.91667 4.75001H10.0947L7.92615 15H5.74992C5.5198 15 5.33325 15.1866 5.33325 15.4167V16C5.33325 16.2301 5.5198 16.4167 5.74992 16.4167H11.5833C11.8134 16.4167 11.9999 16.2301 11.9999 16V15.4167C11.9999 15.1866 11.8134 15 11.5833 15H9.59282L11.7614 4.75001H13.75C13.9801 4.75001 14.1667 4.56346 14.1667 4.33334V3.75001C14.1667 3.51989 13.9801 3.33334 13.75 3.33334H7.91667Z'
      fill={color}
    />
  ));
  return <BaseComponent viewBox='0 0 20 20' ref={ref} dataTestId={dataTestId ?? 'italic-icon-svg'} iconRender={iconRender} {...props} />;
});
